export default __webpack_public_path__ + "static/media/tokenBanner.cc79c475.jpg";